const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY.replace(/\\n/g, "\n");

export async function generateAsymmetricToken(data) {
  const base64 = PUBLIC_KEY.replace("-----BEGIN PUBLIC KEY-----", "")
    .replace("-----END PUBLIC KEY-----", "")
    .replace(/\s/g, "");

  const binary = atob(base64);
  const bytes = new Uint8Array([...binary].map((c) => c.charCodeAt(0)));

  const key = await crypto.subtle.importKey(
    "spki",
    bytes.buffer,
    {
      name: "RSA-OAEP",
      hash: "SHA-1",
    },
    false,
    ["encrypt"]
  );

  const encoded = new TextEncoder().encode(
    JSON.stringify({
      token: data,
      timestamp: Date.now(),
    })
  );

  const encrypted = await crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    key,
    encoded
  );

  return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}
